<template>
    <div class="col-12">
        <h4>{{ __('left_to_be_invoiced') }}</h4>
        <DataTable
            :data="vatRates"
            :options="tableOptions"
            :summary="summary"
        />
    </div>
</template>

<script>
import DataTable from "../../../table/DataTable";

export default {
    name: "LeftToBeInvoicedTable",
    components: {DataTable},
    props: {
        contractItemsSummaries: {
            type: Object,
            required: true,
        },
        contractType: {
            type: Object,
            required: true,
        },
    },
    computed: {
        contractTable() {
            return {
                data: [
                    {name: this.__('item_vat_rate'), valueKey: 'vat_rate_list', type: ''},
                    {name: this.__('document_net_amount'), valueKey: 'net_amount', type: 'money'},
                    {name: this.__('item_gross_amount'), valueKey: 'gross_amount', type: 'money'},
                    {name: this.__('net_amount_left'), valueKey: 'net_amount_left', type: 'money'},
                    {name: this.__('gross_amount_left'), valueKey: 'gross_amount_left', type: 'money'},
                ],
                summary: [
                    {name: this.__('sum')},
                    {valueKey: 'sum_net_amount', type: 'money'},
                    {valueKey: 'sum_gross_amount', type: 'money'},
                    {valueKey: 'sum_net_amount_left', type: 'money'},
                    {valueKey: 'sum_gross_amount_left', type: 'money'},
                ],
            };
        },
        marginContractTable() {
            return {
                data: [
                    {name: '', valueKey: '', type: ''},
                    {name: this.__('value'), valueKey: 'gross_amount', type: 'money'},
                    {name: this.__('margin_amount_included'), valueKey: 'margin', type: 'money'},
                    {name: this.__('value_left'), valueKey: 'gross_amount_left', type: 'money'},
                    {name: this.__('gross_margin_left'), valueKey: 'margin_left', type: 'money'},
                ],
                summary: [
                    {name: this.__('sum')},
                    {valueKey: 'sum_gross_amount', type: 'money'},
                    {valueKey: 'sum_margin', type: 'money'},
                    {valueKey: 'sum_gross_amount_left', type: 'money'},
                    {valueKey: 'sum_margin_left', type: 'money'},
                ],
            };
        },
        tableOptions() {
            return this.contractType.isMargin ? this.marginContractTable : this.contractTable;
        },
        summary() {
            return this.contractItemsSummaries.summary;
        },
        vatRates() {
            return this.contractItemsSummaries.vatRates;
        },
    },
};
</script>
